import {AbstractModel} from '../abstract-model';

export class SimpleStat extends AbstractModel {
  cost: number = 0;
  revenue: number = 0;
  margin: number = 0;

  getMarginPercent(): number {
    if (this.revenue === 0) {
      return 0;
    }

    const margin = this.revenue - this.cost;

    if (margin < 0) {
      return -(1 - (this.revenue / this.cost));
    }

    return margin / this.revenue;
  }
}
